import Button from 'components/Basic/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { setDevMode } from 'store/slices/ToolSlice';

export default function DevModeBtn(){
	const { enabledDevMode, hideSatelliteOverlay } =
		useSelector((state: RootState) => state.toolNewPostions.data);
	const dispatch = useDispatch();
	
	const onClickHandler = () => {
		dispatch(setDevMode({enable:!enabledDevMode}));
	};

	return (
		<Button
			id="developer-mode-btn"
			tooltipContent={'Developer Mode'}
			className={`developer-mode-btn ${enabledDevMode ? 'active' : ''}`}
			disabled={hideSatelliteOverlay}
			onClick ={onClickHandler}>
			<svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M14.9023 1.06067L20.0014 6.76674L14.9023 12.7763" 
					stroke={enabledDevMode ? 'var(--primary)' : 'var(--defaultIconColor)'} 
					strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
				<path d="M6.09766 1.06067L0.998615 6.76674L6.09766 12.7763" 
					stroke={enabledDevMode ? 'var(--primary)' : 'var(--defaultIconColor)'} 
					strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
				<path d="M12.9581 1L7.98047 12.7764" 
					stroke={enabledDevMode ? 'var(--primary)' : 'var(--defaultIconColor)'} 
					strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
			</svg>
		</Button>
	);
}